export const WorkWithUsData = [
  {
    imageName: 'static/svg/cml/fork_lift.svg',
    description: 'Leverage our high-volume tonnage capabilities to scale your logistics operations.'
  },
  {
    imageName: 'static/svg/cml/fixed_location.svg',
    description: 'Monitor multiple storage and distribution locations through a centralized dashboard. ',
  },
  {
    imageName: 'static/svg/cml/package_checked.svg',
    description: 'Access real-time inventory data and track deliveries to enhance operational and dispatch efficiency.'
  },
];
